import { Controller } from "@hotwired/stimulus";

// Levels that fill the classes (24/10/2026): ticking « 5e » selects every 5e
// in the classes field, unticking it takes them out again; the classes stay
// free to pick one by one beside. Both fields are SlimSelect multi-selects;
// each class option names its level in data-level-id.
export default class extends Controller {
  static targets = ["levels", "classrooms"];

  connect() {
    this.previous = this.selectedLevels();
  }

  sync() {
    const now = this.selectedLevels();
    const added = now.filter((level) => !this.previous.includes(level));
    const removed = this.previous.filter((level) => !now.includes(level));
    this.previous = now;
    if (added.length === 0 && removed.length === 0) return;

    const chosen = new Set(Array.from(this.classroomsTarget.selectedOptions).map((option) => option.value));
    Array.from(this.classroomsTarget.options).forEach((option) => {
      const level = option.dataset.levelId;
      if (added.includes(level)) chosen.add(option.value);
      if (removed.includes(level)) chosen.delete(option.value);
    });

    const values = Array.from(chosen);
    if (this.classroomsTarget.slim) {
      this.classroomsTarget.slim.setSelected(values);
    } else {
      Array.from(this.classroomsTarget.options).forEach((option) => { option.selected = chosen.has(option.value); });
      this.classroomsTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  selectedLevels() {
    return Array.from(this.levelsTarget.selectedOptions).map((option) => option.value);
  }
}
